import { useEffect, useRef, useState } from 'react'
import img from '../../../../assets/image 105.png'
import bgImg from '../../../../assets/image 104.jpg'
import badBottom from '../../../../assets/image 105 (2).png'
import badBg from '../../../../assets/img-bg.jpg'
import './index.scss'
import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import classNames from 'classnames'
import { ReactComponent as Play } from '../../../../assets/Rectangle 6.svg'
import GlobalState, { watchVideo } from '../../../../stores/GlobalState'

const ForthScreen = observer(() => {
  const [isbgLoad, setLoad] = useState(false)
  const [isImgLoad, setImgLoad] = useState(false)
  const video = useRef<any>(null)
  const [img1, setImg] = useState<any>(null)
  const [bg, setBg] = useState<any>(null)
  useEffect(() => {
    fetch(img)
      .then((fetchResponse) => {
        if (fetchResponse.ok) {
          return fetchResponse
        }
      })
      .then((response) => response!.blob())
      .then((imageBlob) => {
        const imageObjectURL: any = URL.createObjectURL(imageBlob)
        setImg(imageObjectURL)

        setTimeout(() => {
          setImgLoad(true)
        }, 1000)
      })
  }, [])

  useEffect(() => {
    fetch(bgImg)
      .then((fetchResponse) => {
        if (fetchResponse.ok) {
          return fetchResponse
        }
      })
      .then((response) => response!.blob())
      .then((imageBlob) => {
        const imageObjectURL: any = URL.createObjectURL(imageBlob)
        setBg(imageObjectURL)

        setTimeout(() => {
          setLoad(true)
        }, 1000)
      })
  }, [])

  if (!ContentState.home?.forthscreen) return <></>
  return (
    <section className="screen section business page" id="business">
      <div className="screen__container">
        <div className="screen__row">
          <div
            className="screen__title"
            dangerouslySetInnerHTML={{
              __html: ContentState.home!.forthscreen.title,
            }}
          ></div>
          <div className="screen__wrapper">
            <div
              className="screen__text"
              dangerouslySetInnerHTML={{
                __html: ContentState.home!.forthscreen.text,
              }}
            ></div>
            {window.innerWidth > 760 && (
              <div
                className={classNames(
                  'screen__video desk',
                  GlobalState.video.show && 'hideVideo',
                )}
              >
                <div
                  className="screen__video-text"
                  dangerouslySetInnerHTML={{
                    __html: ContentState.home!.forthscreen.watchText,
                  }}
                ></div>
                <div
                  className="screen__video-play"
                  onClick={() =>
                    watchVideo(
                      ContentState.home!.forthscreen.src,
                      ContentState.home!.forthscreen.poster,
                    )
                  }
                >
                  <Play />
                </div>

                <video
                  ref={video}
                  id="#myVideo"
                  poster={ContentState.home.forthscreen.poster}
                  src={ContentState.home.forthscreen.src}
                  autoPlay={false}
                  preload={'preload'}
                  controls={false}
                >
                  <source src={ContentState.home.forthscreen.src}></source>
                </video>
              </div>
            )}
          </div>
        </div>

        {window.innerWidth <= 760 && !GlobalState.video.show && (
          <div className={classNames('screen__video mob')}>
            <div
              className="screen__video-text"
              dangerouslySetInnerHTML={{
                __html: ContentState.home.forthscreen.watchText,
              }}
            ></div>
            <div
              className={classNames('screen__video-play')}
              onClick={() =>
                watchVideo(
                  ContentState.home!.forthscreen.src,
                  ContentState.home!.forthscreen.poster,
                )
              }
            >
              <Play />
            </div>
            <video
              id="#myVideo"
              poster={ContentState.home.forthscreen.poster}
              ref={video}
              src={ContentState.home.forthscreen.src}
              autoPlay={false}
              preload={'preload'}
              controls={false}
            >
              <source src={ContentState.home.forthscreen.src}></source>
            </video>
          </div>
        )}
        <div className="screen__bottom">
         <div className="screen__bottom-btns">
            <a
              href={ContentState.subMenu?.forbusinessLink}
              className="button  black mr29"
            >
              <span> {ContentState.home.buttonYou.title}</span>
            </a>
            <a className="button white" href={ContentState.subMenu?.foryouLink}>
              <span>{ContentState.home.buttonBusiness.title}</span>
            </a>
          </div>
        </div>
      </div>

      <div
        className={classNames('screen__bg', isbgLoad && 'ready-bg')}
        style={{ backgroundImage: `url('${bg ? bg : badBg}')` }}
      ></div>
      <img
        src={img1 ? img1 : badBottom}
        className={classNames('screen__grass', isImgLoad && 'ready-img')}
      />
    </section>
  )
})

export default ForthScreen
